import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import api from "@/api";

export const Testimonials = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section id="reviews" data-testid="testimonials-section" className="py-20 lg:py-32 bg-[#111827] border-y border-amber-500/15">
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="mb-14">
          <p className="text-xs font-mono-brand uppercase tracking-[0.25em] text-amber-400 mb-4">05 — Word Of Mouth</p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-condensed font-extrabold uppercase tracking-tight leading-none">
            Neighbours <span className="text-amber-500">Talking</span>
          </h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <motion.blockquote key={r.id} data-testid={`testimonial-${r.id}`}
                               initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
                               viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.55, delay: (i % 3) * 0.1 }}
                               className="bg-[#0F172A] border border-amber-500/15 p-8 relative hover:border-amber-500/50 transition-colors duration-300">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-amber-500/15" />
              <div className="flex gap-1 mb-5">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} className={`w-4 h-4 ${n <= r.rating ? "text-amber-500 fill-amber-500" : "text-slate-700"}`} />
                ))}
              </div>
              <p className="text-base leading-relaxed text-slate-300 mb-6">“{r.message}”</p>
              <footer className="flex items-center justify-between">
                <span className="font-condensed font-bold uppercase tracking-wide text-slate-100">{r.name}</span>
                <span className="text-xs font-mono-brand uppercase tracking-[0.15em] text-amber-400">{r.service_name}</span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
